import { createStyles } from 'antd-style'

export const useStyle = createStyles(
  (_, position: React.CSSProperties['transform']) => ({
    arrowSwapPosition: {
      transform: position
    },

    sortButton: {
      '& .ant-dropdown-trigger': {
        borderTopLeftRadius: 0,
        borderBottomLeftRadius: 0,
        borderLeft: 'none'
      }
    },

    sortButtonTrigger: {
      borderTopRightRadius: 0,
      borderBottomRightRadius: 0
    }
  })
)
